import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PaginatedSearchResponse } from 'lib';
import { EnterpriseApplicationDto, OrganizationAttributeName } from '../interfaces/enterprise-application-dto';

export interface BulkAttributeUpdateRequest {
    organizationIds: number[];
    attributeName: OrganizationAttributeName;
    value: string;
}

@Injectable({
    providedIn: 'root'
})
export class EnterpriseApplicationsService {
    private readonly http = inject(HttpClient);


    private readonly baseUrl = environment.apiUrl + '/api/v1/enterprises';

    getApplications(enterpriseId: number, page: number, itemsPerPage: number,
        attributes: OrganizationAttributeName[],
        sortBy = 'organization.urlPrefix', sortOrder: 'ASC' | 'DESC' = 'ASC'): Observable<PaginatedSearchResponse<EnterpriseApplicationDto>> {
        const params = new HttpParams()
            .set('page', page)
            .set('size', itemsPerPage)
            .set('attributes', attributes.join(','))
            .set('sort', `${sortBy},${sortOrder.toLowerCase()}`);

        return this.http.get<PaginatedSearchResponse<EnterpriseApplicationDto>>(
            `${this.baseUrl}/${enterpriseId}/applications`,
            { params }
        );
    }

    getAllConfirmedOrgIds(enterpriseId: number, totalItems: number): Observable<number[]> {
        const params = new HttpParams()
            .set('page', 0)
            .set('size', totalItems);

        return this.http.get<PaginatedSearchResponse<EnterpriseApplicationDto>>(
            `${this.baseUrl}/${enterpriseId}/applications`,
            { params }
        ).pipe(
            map(response => response.content.map(item => item.organizationId))
        );
    }

    setApplicationAttribute(enterpriseId: number, request: BulkAttributeUpdateRequest): Observable<void> {
        return this.http.patch<void>(
            `${this.baseUrl}/${enterpriseId}/applications`,
            request
        );
    }
}
